// Object.entries polyfill for older browsers (ES5 compatible)
// This will be shared with other microfrontends

/* eslint-disable */
// @ts-nocheck
(function () {
  if (typeof Object.entries === "function") return;

  Object.entries = function (obj) {
    if (obj === null || obj === undefined) {
      throw new TypeError("Cannot convert undefined or null to object");
    }

    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);

    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }

    return resArray;
  };
})();

// Also add Object.values polyfill since it's often used together
(function () {
  if (typeof Object.values === "function") return;

  Object.values = function (obj) {
    if (obj === null || obj === undefined) {
      throw new TypeError("Cannot convert undefined or null to object");
    }

    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);

    while (i--) {
      resArray[i] = obj[ownProps[i]];
    }

    return resArray;
  };
})();

